import React from 'react';
import { ClientInvitation } from '../../../../../hooks/api/useMyOrganizationClientInvitations';
import { getIntl } from '../../../../../utils/intl';
import { Paper } from '../../../../v2BaseComponents/Paper';
import OrganizationInviteLogo from '../../../OrganizationInviteLogo';
import Text from '../../../../v2BaseComponents/Text';
import getName from '../../../../../utils/getName';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';
import Stack, { contentStackSpacing } from '../../../../v2BaseComponents/Stack';
import GateButtons from '../GateButtons';

const intl = getIntl('organization-client-invitation-intro-step', {
    welcome: 'Welcome {name},',
    begin: 'Begin',
    notNow: 'Not Now',
});

export type IntroStepOwnProps = {
    clientInvitation: ClientInvitation;
    onNext: () => void;
    onRemindMeLater: () => void;
};

export type IntroStepProps = IntroStepOwnProps;

const IntroStep: React.FC<IntroStepProps> = (props) => {
    return (
        <Paper>
            <MainContentContainer>
                <Stack vertical fullWidth space={contentStackSpacing}>
                    <OrganizationInviteLogo
                        organizationId={props.clientInvitation.organization.organizationId}
                        organizationClientInviteId={props.clientInvitation.organizationClientInvitationId}
                    />
                    <Text variant="h4">
                        {intl('welcome', {
                            name: getName({
                                firstName: props.clientInvitation.clientOrganizerFirstName,
                                lastName: props.clientInvitation.clientOrganizerLastName,
                            }),
                        })}
                    </Text>
                    <Text variant="body-1">{props.clientInvitation.message}</Text>
                    <Text variant="body-1">{props.clientInvitation.organization.metadata.name}</Text>
                    <GateButtons
                        primaryButtonProps={{
                            variant: 'primary',
                            title: intl('begin'),
                            onPress: props.onNext,
                            icon: 'ArrowRightCircle',
                            testID: 'intro-step-continue-button',
                        }}
                        secondaryButtonProps={{
                            variant: 'secondary',
                            title: intl('notNow'),
                            onPress: props.onRemindMeLater,
                            icon: 'ArrowRightCircle',
                            testID: 'client-invite-not-now-button',
                        }}
                    />
                </Stack>
            </MainContentContainer>
        </Paper>
    );
};

export default React.memo(IntroStep);
